// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3yOsu","tab":"ProcedureTabs_tab__VviED"};